// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"styles_titleWrapper__3zao_","title":"styles_title__KnUGy","buttonWrapper":"styles_buttonWrapper__aMsqr","buttonClass":"styles_buttonClass__NQIvy","icon":"styles_icon__vEOUY"};
module.exports.__checksum = "99d7080be215"